/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React from "react";
import "./DiscographySection.css";

function DiscographySection() {
  const artists = [
    {
      name: "C-Kan",
      imageUrl: "https://is3-ssl.mzstatic.com/image/thumb/Purple118/v4/a3/73/23/a3732310-4b5d-78ba-2f3a-57b2788d96c6/source/512x512bb.jpg",
      spotifyUrl: "https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO12hDAQ?utm_source=generator&theme=0",
      websiteUrl: "https://ckan.mx"
    },
    {
      name: "Melodico",
      imageUrl: "https://i.scdn.co/image/ab6761610000e5ebf7ec6ac3c9321c4c9351d9ea",
      spotifyUrl: "https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO0s5tps?utm_source=generator",
      websiteUrl: ""
    },
  ];

  const handleCardClick = (url) => {
    window.location.href = url;
  }

    return (
      <div className="discography-section">
      {artists.map((artist) => (
        <a key={artist.name} className="artist-card-link" href={artist.websiteUrl}>
          <div className="artist-card" onClick={() => handleCardClick(artist.websiteUrl)}>
            <img className="artist-image" src={artist.imageUrl} alt={artist.name} />
            <div className="artist-content">
              <h3 className="artist-name">{artist.name}</h3>
              <div className="spotify-player">
                <iframe
                  src={artist.spotifyUrl}
                  width="400"
                  height="380"
                  frameBorder="0"
                  allowtransparency="true"
                  allow="encrypted-media"
                  title={`${artist.name} Spotify`}
                ></iframe>
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
}

export default DiscographySection;
